import { render } from "./UiListItem.vue?vue&type=template&id=b3085800"
import script from "./UiListItem.vue?vue&type=script&lang=js"
export * from "./UiListItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bot-v2/bot-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__